import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

const day = (iso) => new Date(iso).toLocaleDateString([], { day: "numeric", month: "short", year: "numeric" });
export const when = (iso) => new Date(iso).toLocaleString([], { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
export const approvalText = (s) => (s?.status === "approved" ? `Approved · ${s.by} · ${day(s.at)}` : s?.status === "changes" ? `Changes requested · ${s.by}` : "Pending");

const NAME = "aludraft_client_name", KEY = "aludraft_client_key";
export const clientName = () => localStorage.getItem(NAME) || "";
export const setClientName = (n) => localStorage.setItem(NAME, n.trim());
export const clientKey = () => {
  let k = localStorage.getItem(KEY);
  if (!k) { k = crypto.randomUUID?.() || `${Date.now()}${Math.random()}`.replace(".", ""); localStorage.setItem(KEY, k); }
  return k;
};

export const reviewTotals = (items, summary) => ({
  approved: items.filter((i) => summary[i.id]?.status === "approved").length,
  open: items.reduce((a, i) => a + (summary[i.id]?.open || 0), 0),
});

export function useFeedback(url) {
  const [fb, setFb] = useState({ entries: [], summary: {} });
  const reload = useCallback(() => (url ? api.get(url).then(({ data }) => setFb(data)).catch(() => {}) : Promise.resolve()), [url]);
  useEffect(() => {
    reload();
    const t = setInterval(reload, 60000);
    window.addEventListener("focus", reload);
    return () => { clearInterval(t); window.removeEventListener("focus", reload); };
  }, [reload]);
  return [fb, reload];
}
